




























import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AdminUserResult } from "@futuri/cloudsso-client/src/client/types/admin";

@Component
export default class UserCognito extends Vue {
  @Getter("currentUser", { namespace: "adminUserPost" })
  currentUser?: AdminUserResult;

  get displayEmail() {
    return this.currentUser?.email;
  }
  get displayCognitoImported() {
    return `Account imported into Cognito: no`;
  }
}
